import {createActions} from 'client/framework';

const normalActions = [
  'ARCHIVE_CLASSROOM',
  'DELETE_CLASSROOM',
  'INITIALIZE_SETTINGS',
  'MESSAGE_SHOWN',
  'REMOVE_SELF_FROM_CLASSROOM',
  'RESET_STORE',
  'SAVE_CLASSROOM',
  'SCHOOL_ASSOCIATION_CHANGE',
  'SET_CLASS_NAME',
  'SET_SELECTED_SUBJECTS',
  'UNARCHIVE_CLASSROOM'
];

const teacherClassroomSettingsActions = createActions(null, normalActions);
export default teacherClassroomSettingsActions;
